<template>
    <div class="table__wrap">
        <div class="table__nav">
            <el-tabs v-model="activeName">
                <el-tab-pane label="基本信息" name="first">
                    <div class="jiben_nav">
                        <el-row>
                            <el-col :span="12">
                                <div class="find">
                                    <el-form ref="form1" :model="form1" :inline="true">
                                        <el-form-item
                                          label=""
                                          prop="input1"
                                        >
                                          <el-input type="" v-model="form1.input1" placeholder="请输入姓名/工号" size="small" clearable style="width:300px;padding-right:5px" maxlength="6"></el-input>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button size="small" type="primary" @click.prevent="find1('form1')" @keyup.enter.native="null">搜索</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </el-col>
                            <el-col :span="12">
                              <DepartmentCascade  size="small" ref="cascadeOne" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne11" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo11" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree11" v-on:getDepartmentFour="showDepartmentFour11" v-bind:four="parentMsgFour"></DepartmentCascade>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="jiben_content">
                        <el-table :data="newtableData1" style="width: 100%">
                            <el-table-column prop="id" label="工号" align="center" ></el-table-column>
                            <el-table-column prop="name" label="姓名" align="center" ></el-table-column>
                            <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
                            <el-table-column prop="list" label="公司" show-overflow-tooltip align="center"></el-table-column>
                            <el-table-column prop="mobile" label="手机" align="center"></el-table-column>
                            <!-- <el-table-column>
                                <template slot-scope="scope">
                                    <div class="operate hide">
                                        <el-button type="text" size="small">
                                            <span @click="xiugai(scope.row.id)">修改</span>
                                        </el-button>
                                        <el-button type="text" size="small" >
                                            <span @click="deleteStaff(scope.row.id)">删除</span>
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </div>
                    <div class="jiben_clearfix">
                        <div class="jiben_pagination">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" :page-sizes="pageSizes" layout="total,sizes,prev, pager, next" :total="totalList1">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="详细信息" name="second">
                    <div class="xiangxi_nav">
                         <el-row>
                            <el-col :span="8">
                                <div class="find">
                                    <el-form ref="form2" :model="form2" :inline="true">
                                        <el-form-item
                                          label=""
                                          prop="input2"
                                        >
                                          <el-input type="" v-model="form2.input2" placeholder="请输入姓名/工号" size="small" clearable style="width:300px;padding-right:5px" maxlength="6"></el-input>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button size="small" type="primary" @click.prevent="find2('form2')">搜索</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </el-col>
                            <el-col :span="4">
                              <div class="add">
                                <el-button size="small" type="primary" @click="add">新增员工</el-button>
                                <el-button size="small" type="primary" @click="daochu">导出</el-button>
                              </div>
                            </el-col>
                            <el-col :span="12">
                              <DepartmentCascade  size="small" ref="cascadeOne" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne12" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo12" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree12" v-on:getDepartmentFour="showDepartmentFour12" v-bind:four="parentMsgFour"></DepartmentCascade>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="xiangxi_content">
                        <el-table :data="tableData2" style="width: 100%" @cell-mouse-enter="showOperate" @cell-mouse-leave="hideOperate">
                            <el-table-column prop="id" label="工号" width="50"></el-table-column>
                            <el-table-column prop="name" label="姓名" ></el-table-column>
                            <el-table-column prop="email" label="邮箱" ></el-table-column>
                            <el-table-column prop="" label="公司" width="120">
                              <template slot-scope="scope">
                                <div>{{scope.row.jiagou_first_name}}</div>
                                <div>{{scope.row.jiagou_second_name}}</div>
                                <div>{{scope.row.jiagou_third_name}}</div>
                                <div>{{scope.row.jiagou_forth_name}}</div>
                              </template>
                            </el-table-column>
                            <el-table-column prop="area" label="地区" ></el-table-column>
                            <el-table-column prop="indate" label="入职时间" ></el-table-column>
                            <el-table-column prop="zhiwei" label="职位" ></el-table-column>
                            <el-table-column prop="level" label="级别" ></el-table-column>
                            <el-table-column prop="birth" label="生日" ></el-table-column>
                            <el-table-column prop="mobile" label="手机" ></el-table-column>
                            <el-table-column prop="xueli" label="学历" ></el-table-column>
                            <el-table-column prop="xuewei" label="学位" ></el-table-column>
                            <el-table-column prop="xuexiao" label="学校" ></el-table-column>
                            <el-table-column prop="zhuanye" label="专业" ></el-table-column>
                            <el-table-column prop="photo" label="照片" >
                             <template slot-scope="scope">
                                <img :src="scope.row.photo" alt="" style="width: 80px;height: 80px">
                             </template>
                            </el-table-column>
                            <el-table-column>
                                <template slot-scope="scope">
                                    <div class="operate hide">
                                        <el-button type="text" size="small">
                                            <span @click="xiugai(scope.row.id,$event)">修改</span>
                                        </el-button>
                                        <el-button type="text" size="small" >
                                            <span @click="deleteStaff(scope.row.id)">删除</span>
                                        </el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="xiangxi_clearfix">
                        <div class="xiangxi_pagination">
                            <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="pageNum2" :page-size="pageSize2" :page-sizes="pageSizes2" layout="total,sizes,prev, pager, next" :total="totalList2" v-if="totalList2!=0">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="离职人员" name="third">
                  <div class="lizhi_nav">
                    <div class="find">
                      <el-form ref="form3" :model="form3" :inline="true">
                          <el-form-item
                            label=""
                            prop="input3"
                          >
                            <el-input type="" v-model="form3.input3" placeholder="请输入姓名/工号" size="small" clearable style="width:300px;padding-right:5px" maxlength="6"></el-input>
                          </el-form-item>
                          <el-form-item>
                              <el-button size="small" type="primary" @click.prevent="find3('form3')">搜索</el-button>
                          </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div class="lizhi_content">
                    <el-table :data="tableData3" style="width: 100%">
                      <el-table-column prop="id" label="工号" width="50"></el-table-column>
                      <el-table-column prop="name" label="姓名" ></el-table-column>
                      <el-table-column prop="email" label="邮箱" ></el-table-column>
                      <el-table-column prop="" label="公司">
                        <template slot-scope="scope">
                          <div>{{scope.row.jiagou_first_name}}</div>
                          <div>{{scope.row.jiagou_second_name}}</div>
                          <div>{{scope.row.jiagou_third_name}}</div>
                          <div>{{scope.row.jiagou_forth_name}}</div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="area" label="地区" ></el-table-column>
                      <el-table-column prop="indate" label="入职时间" ></el-table-column>
                      <el-table-column prop="zhiwei" label="职位" ></el-table-column>
                      <el-table-column prop="level" label="级别" ></el-table-column>
                      <el-table-column prop="birth" label="生日" ></el-table-column>
                      <el-table-column prop="mobile" label="手机" ></el-table-column>
                      <el-table-column prop="xueli" label="学历" ></el-table-column>
                      <el-table-column prop="xuewei" label="学位" ></el-table-column>
                      <el-table-column prop="xuexiao" label="学校" ></el-table-column>
                      <el-table-column prop="zhuanye" label="专业" ></el-table-column>
                      <el-table-column prop="photo" label="照片" >
                        <template slot-scope="scope">
                          <img :src="scope.row.photo" alt="" style="width: 80px;height: 80px">
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                <div class="lizhi_clearfix">
                  <div class="lizhi_pagination">
                      <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="pageNum3" :page-size="pageSize3" :page-sizes="pageSizes3" layout="total,sizes,prev, pager, next" :total="totalList3">
                      </el-pagination>
                  </div>
                </div>
                </el-tab-pane>
            </el-tabs>
        </div>

        <el-dialog
          title="导出数据"
          :visible.sync="dialogVisible"
          width="60%"
          :show-close="false"
          >
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="部门">
              <DepartmentCascade  size="small" ref="cascadeOne" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne13" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo13" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree13" v-on:getDepartmentFour="showDepartmentFour13" v-bind:four="parentMsgFour"></DepartmentCascade>
            </el-form-item>
            <el-form-item label="下载字段" prop="type">
              <el-checkbox-group v-model="form.type">
                <el-checkbox label="id"  size="small" :disabled="true" name="type" :checked="true">工号</el-checkbox>
                <el-checkbox label="name" size="small" :checked="true" :disabled="true" name="type">姓名</el-checkbox>
                <el-checkbox label="email" size="small" name="type">邮箱</el-checkbox>
                <el-checkbox label="area" size="small" name="type">地区</el-checkbox>
                <el-checkbox label="indate" size="small" name="type">入职时间</el-checkbox>
                <el-checkbox label="zhiwei" size="small" name="type">职位</el-checkbox>
                <el-checkbox label="first" size="small" name="type">一级部门</el-checkbox>
                <el-checkbox label="second" size="small" name="type">二级部门</el-checkbox>
                <el-checkbox label="third" size="small" name="type">三级部门</el-checkbox>
                <el-checkbox label="fourth" size="small" name="type">四级部门</el-checkbox>
                <el-checkbox label="level" size="small" name="type">级别</el-checkbox>
                <el-checkbox label="birth" size="small" name="type">生日</el-checkbox>
                <el-checkbox label="mobile" size="small" name="type">手机</el-checkbox>
                <el-checkbox label="xueli" size="small" name="type">学历</el-checkbox>
                <el-checkbox label="xuewei" size="small" name="type">学位</el-checkbox>
                <el-checkbox label="xuexiao" size="small" name="type">学校</el-checkbox>
                <el-checkbox label="zhuanye" size="small" name="type">专业</el-checkbox>
                <el-checkbox label="photo" size="small" name="type">照片</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="quxiao('form')">取 消</el-button>
            <el-button  @click="clickDaoChu('form')">确 定</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
import DepartmentCascade from '../components/DepartmentCascade.vue'
export default {
  data () {
    return {
      activeName: '',
      newtableData1: [],
      newtableData2: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      pageSize: 10,
      pageNum: 1,
      pageSizes: [10, 20, 50],
      totalList1: 0,
      pageSize2: 30,
      pageNum2: 1,
      pageSizes2: [30],
      totalList2: 0,
      pageSize3: 10,
      pageNum3: 1,
      pageSizes3: [10],
      totalList3: 0,
      form1: {
        input1: ''
      },
      form2: {
        input2: ''
      },
      form3: {
        input3: ''
      },
      parentMsgOne: '',
      parentMsgTwo: '',
      parentMsgThree: '',
      parentMsgFour: '',
      secondApart: '',
      forthApart: '',
      thirdApart: '',
      firstApart: '',
      secondApart1: '',
      forthApart1: '',
      thirdApart1: '',
      firstApart1: '',
      secondApart2: '',
      forthApart2: '',
      thirdApart2: '',
      firstApart2: '',
      dialogVisible: false,
      form: {
        type: []
      }
    }
  },
  components: {
    DepartmentCascade
  },
  created () {
    if (sessionStorage.getItem('page')) {
      this.activeName = 'second'
    } else {
      this.activeName = 'first'
    }

    if (sessionStorage.getItem('top') && sessionStorage.getItem('pageNum2')) {
      this.pageNum2 = parseInt(sessionStorage.getItem('pageNum2'))
    }
    this.getListTwo()
    sessionStorage.setItem('page', '')
    this.getListOne()
    this.getListThree()
  },
  methods: {
    showOperate (row, column, cell) {
      let targetEl = cell.parentElement.querySelector('.operate')
      targetEl.classList.remove('hide')
    },
    hideOperate (row, column, cell) {
      let targetEl = cell.parentElement.querySelector('.operate')
      targetEl.classList.add('hide')
    },
    getCurrentList () {
      this.newtableData1 =
        this.tableData1 &&
        this.tableData1.slice(
          (this.pageNum - 1) * this.pageSize,
          this.pageNum * this.pageSize
        )
    },
    getCurrentList2 () {
      this.newtableData2 =
        this.tableData2 &&
        this.tableData2.slice(
          (this.pageNum - 1) * this.pageSize,
          this.pageNum * this.pageSize
        )
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getCurrentList()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getCurrentList()
    },
    handleSizeChange2 (val) {
      this.pageSize2 = val
      if (val < this.totalList2) {
        this.getListTwo()
      }
    },
    handleCurrentChange2 (val) {
      this.pageNum2 = val
      this.getListTwo()
    },
    handleSizeChange3 (val) {
      this.pageSize3 = val
      if (val < this.totalList3) {
        this.getListThree()
      }
    },
    handleCurrentChange3 (val) {
      this.pageNum3 = val
      this.getListThree()
    },
    add () {
      sessionStorage.setItem('id', '')
      this.$router.push('/addstaff')
    },
    getListOne () {
      let self = this
      this.$axios
        .post('/api/yuangong/simple', {
          gong_id: this.form1.input1,
          name: this.form1.input1,
          jiagou_first: this.firstApart,
          jiagou_second: this.secondApart,
          jiagou_third: this.thirdApart,
          jiagou_forth: this.forthApart
        })
        .then(function (res) {
          self.tableData1 = res.data.yuangong_data
          // self.tableData2 = res.data.yuangong_data;
          self.totalList1 = res.data.number
          for (var i = 0; i < self.tableData1.length; i++) {
            var first_name = self.tableData1[i]['jiagou_first_name']
            var second_name = self.tableData1[i]['jiagou_second_name']
            var third_name = self.tableData1[i]['jiagou_third_name']
            var forth_name = self.tableData1[i]['jiagou_forth_name']
            if (
              (second_name === '') &
              (third_name == '') &
              (forth_name == '')
            ) {
              self.tableData1[i].list = first_name
            } else if ((third_name == '') & (forth_name == '')) {
              self.tableData1[i].list = first_name + '-' + second_name
            } else if (forth_name == '') {
              self.tableData1[i].list =
                first_name + '-' + second_name + '-' + third_name
            } else {
              self.tableData1[i].list =
                first_name +
                '-' +
                second_name +
                '-' +
                third_name +
                '-' +
                forth_name
            }
          }
          self.getCurrentList()
        })
    },
    getListTwo () {
      let self = this
      this.$axios
        .post('/api/yuangong/list2', {
          gong_id: this.form2.input2,
          name: this.form2.input2,
          page: this.pageNum2,
          num: this.pageSize2,
          jiagou_first: this.firstApart1,
          jiagou_second: this.secondApart1,
          jiagou_third: this.thirdApart1,
          jiagou_forth: this.forthApart1
        })
        .then(function (res) {
          self.tableData2 = res.data.yuangong_data
          self.totalList2 = res.data.number
          if (
            sessionStorage.getItem('top') &&
            sessionStorage.getItem('pageNum2')
          ) {
            setTimeout(() => {
              // self.pageNum2 = parseInt(sessionStorage.getItem("pageNum2"));
              window.scrollTo(0, parseInt(sessionStorage.getItem('top')))
              sessionStorage.setItem('top', '')
              sessionStorage.setItem('pageNum2', '')
            }, 500)
          }
        })
    },
    getListThree () {
      let self = this
      this.$axios
        .post('/api/yuangong/resign', {
          gong_id: this.form3.input3,
          name: this.form3.input3,
          page: this.pageNum3,
          num: this.pageSize3,
          jiagou_first: this.firstApart1,
          jiagou_second: this.secondApart1,
          jiagou_third: this.thirdApart1,
          jiagou_forth: this.forthApart1
        })
        .then(function (res) {
          self.tableData3 = res.data.yuangong_data
          self.totalList3 = res.data.number
        })
    },
    deleteStaff (id) {
      let self = this
      this.$axios
        .post('/api/yuangong/delete2', {
          gong_id: id
        })
        .then(function () {
          self.getListTwo()
          self.getCurrentList()
        })
    },
    xiugai (id, event) {
      var a = event.currentTarget.offsetParent.offsetTop
      sessionStorage.setItem('top', a)
      sessionStorage.setItem('pageNum2', this.pageNum2)

      this.$router.push({
        path: '/addstaff',
        query: {
          id: id
        }
      })
    },
    find1 (formName) {
      let self = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          self.getListOne()
        }
      })
    },
    find2 (formName) {
      let self = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          self.getListTwo()
        }
      })
    },
    find3 (formName) {
      let self = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          self.getListThree()
        }
      })
    },
    showDepartmentOne11: function (one) {
      let self = this
      this.firstApart = one
      self.getListOne()
    },
    showDepartmentTwo11: function (two) {
      let self = this
      this.secondApart = two
      self.getListOne()
    },
    showDepartmentThree11: function (three) {
      let self = this
      this.thirdApart = three
      self.getListOne()
    },
    showDepartmentFour11 (four) {
      let self = this
      this.forthApart = four
      self.getListOne()
    },
    showDepartmentOne12: function (one) {
      let self = this
      this.firstApart1 = one
      self.getListTwo()
    },
    showDepartmentTwo12: function (two) {
      let self = this
      this.secondApart1 = two
      self.getListTwo()
    },
    showDepartmentThree12: function (three) {
      let self = this
      this.thirdApart1 = three
      self.getListTwo()
    },
    showDepartmentFour12 (four) {
      let self = this
      this.forthApart1 = four
      self.getListTwo()
    },
    showDepartmentOne13: function (one) {
      this.firstApart2 = one
    },
    showDepartmentTwo13: function (two) {
      this.secondApart2 = two
    },
    showDepartmentThree13: function (three) {
      this.thirdApart2 = three
    },
    showDepartmentFour13 (four) {
      this.forthApart2 = four
    },
    daochu () {
      let self = this
      self.dialogVisible = true
    },
    quxiao (formName) {
      let self = this
      self.$refs[formName].resetFields()
      self.$refs.cascadeOne.getClear()
      self.dialogVisible = false
    },
    clickDaoChu (formName) {
      let self = this
      this.$axios
        .post('/api/yuangong/down', {
          jiagou_first: this.firstApart2,
          jiagou_second: this.secondApart2,
          jiagou_third: this.thirdApart2,
          jiagou_forth: this.forthApart2,
          export: this.form.type
        })
        .then(res => {
          // 处理返回的文件流
          var downloadElement = document.createElement('a')
          downloadElement.href = res.data.url
          downloadElement.click() // 点击下载
          self.$refs.cascadeOne.getClear()
          self.$refs[formName].resetFields()
          self.dialogVisible = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  &__wrap {
    margin-top: 20px;
    border-radius: 3px;
    min-width: 1340px;
    background-color: rgba(255, 255, 255, 1);
  }
}
.jiben_content {
  margin: 0px 20px 0 20px;
  border: 1px solid #e9e9e9;
}
.jiben_nav {
  padding: 20px 20px 0 20px;
}
.hide {
  visibility: hidden;
}
.xiangxi_nav {
  padding: 20px 20px 0 20px;
  font-size: 14px;
}
.xiangxi_content {
  margin: 0px 20px 0 20px;
  border: 1px solid #e9e9e9;
}
.jiben_pagination {
  float: right;
  padding: 10px;
}
.xiangxi_pagination {
  float: right;
  padding: 10px;
}
.add {
  margin-top: 3px;
}
.lizhi_nav {
  padding: 20px 20px 0 20px;
}
.lizhi_content {
  margin: 0px 20px 0 20px;
  border: 1px solid #e9e9e9;
}
.lizhi_pagination {
  float: right;
  padding: 10px;
}
</style>
